import type { SVGProps } from 'react';
const DawnFlagKR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-KR_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-KR_svg__a)">
      <path
        fill="#E01B41"
        fillRule="evenodd"
        d="M11 11.733c2.025 0 3.666-1.671 3.666-3.733S13.025 4.267 11 4.267 7.333 5.938 7.333 8 8.975 11.733 11 11.733"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-KR_svg__b"
        width={8}
        height={8}
        x={7}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M11 11.733c2.025 0 3.666-1.671 3.666-3.733S13.025 4.267 11 4.267 7.333 5.938 7.333 8 8.975 11.733 11 11.733"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#dawn-flag-KR_svg__b)">
        <path
          fill="#0E4B9C"
          fillRule="evenodd"
          d="M7.333 8.533c1.047 1 2.619 1.6 3.666 0 1.048-1.6 3.143-1.6 3.667 0s0 3.2 0 3.2H7.333s-1.048-4.2 0-3.2"
          clipRule="evenodd"
        />
      </g>
      <path
        fill="#262626"
        fillRule="evenodd"
        d="M16.399 2.979a.34.34 0 0 0-.123.459l1.242 2.19c.091.161.293.215.452.122l.333-.195a.34.34 0 0 0 .123-.46l-1.243-2.19a.327.327 0 0 0-.452-.122zm-1.361.8a.34.34 0 0 0-.123.459l1.242 2.191c.091.16.294.214.452.121l.333-.195a.34.34 0 0 0 .123-.46l-1.243-2.19a.327.327 0 0 0-.452-.122zM3.574 10.904a.34.34 0 0 1 .123-.459l.333-.195a.327.327 0 0 1 .451.12l1.243 2.192a.34.34 0 0 1-.123.46l-.333.195a.327.327 0 0 1-.451-.121zm1.484-1.259a.34.34 0 0 0-.123.46l1.243 2.19c.09.16.293.215.451.122l.333-.196a.34.34 0 0 0 .123-.459L5.842 9.571a.327.327 0 0 0-.452-.121zm11.1-.074a.327.327 0 0 1 .451-.121l.333.195a.34.34 0 0 1 .123.46l-1.243 2.19a.327.327 0 0 1-.452.122l-.332-.196a.34.34 0 0 1-.123-.459zm1.812.679a.327.327 0 0 0-.452.12l-1.242 2.192a.34.34 0 0 0 .123.46l.332.195c.159.093.361.039.452-.121l1.243-2.192a.34.34 0 0 0-.123-.459zM4.817 2.904a.327.327 0 0 1 .451-.12l.333.195a.34.34 0 0 1 .123.459L4.48 5.628a.327.327 0 0 1-.451.122l-.333-.195a.34.34 0 0 1-.123-.46zm1.812.68a.327.327 0 0 0-.451.12L4.935 5.896a.34.34 0 0 0 .123.458l.332.196c.16.093.361.04.452-.121l1.243-2.191a.34.34 0 0 0-.123-.46z"
        clipRule="evenodd"
        opacity={0.75}
      />
    </g>
  </svg>
);
export default DawnFlagKR;
